<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" fill="none">
    <rect width="45" height="45" rx="22.5" fill="#383838" />
    <path
      d="M25.8173 29.7913L15.961 19.935L14 21.896L23.8563 31.7523L25.8173 29.7913ZM25.8165 14.0001L23.8555 12.0391L13.9994 21.8951L15.9604 23.8562L25.8165 14.0001Z"
      fill="white"
    />
  </svg>
</template>
